export class DefaultLandingPage {
    public PageId: number = 0;
    public ResourceKeyName: string = "";
    public ControllerName: string = "";
    public ControllerMethod: string = "";
    public DlrLoginOnly: boolean = false;
    public Description: string = "";
    public Active: boolean = false;
    public SortOrder: number = -1;
    constructor(defaultLandingPage: DefaultLandingPage) {
        this.PageId = defaultLandingPage.PageId || 0;
        this.ResourceKeyName = defaultLandingPage.ResourceKeyName || "";
        this.ControllerName = defaultLandingPage.ControllerName || "";
        this.ControllerMethod = defaultLandingPage.ControllerMethod || "";
        this.DlrLoginOnly = defaultLandingPage.DlrLoginOnly || false
        this.Description = defaultLandingPage.Description || "";
        this.Active = defaultLandingPage.Active || false;
        this.SortOrder = defaultLandingPage.SortOrder || -1

    }
}


